<template>
    <div class="lgn-input" :class="[{'is-prefix' : prefix},{'is-suffix' : suffix}, {'is-disabled' : disabled}]">
        <slot name="preSelect">
 
        </slot>
        <input class="lgn-input__inner" :placeholder="placeholder" :disabled="disabled" autocomplete :type="inputType" v-model="inputValue" @change="sendValue()" @focus="viewSuffix(true)" @focusout="viewSuffix(false)" spellcheck="false">
        <span class="lgn-input__prefix" v-show="showPrefix">
            <span class="lgn-input__prefix-icon"></span>
        </span>
        <span class="lgn-input__suffix" v-show="showSuffix || (inputValue && inputValue != 0)">
            <span class="lgn-input__suffix-icon" 
                :class="[{'is-password' : type == 'password'},
                {'is-password-hide' : type == 'password' && inputType != 'password'},
                suffixIcon]"
                @click="type == 'password' ? changeType() : suffixMethod()"
            ></span>
        </span>
    </div>
</template>
<script>
export default {
    name: "lgnInput",
    data(){
        return{
            inputType: this.type,
            inputValue: this.value,
            showPrefix: true,
            showSuffix: true
        }
    },
    props: {
        type: String,
        value: null,
        prefix: null,
        suffix: null,
        placeholder: null,
        suffixMethod: null,
        suffixIcon: null,
        disabled: null
    },
    methods: {
        sendValue(){
            this.$emit("input", this.inputValue);
        },
        viewSuffix(status){
            if(this.type == 'password'){
                if(status == false && (!this.inputValue || this.inputValue.trim().length == 0)){
                this.inputType="password";
            }
            this.showSuffix = status;
            }
        },
        changeType(type){
            if(!type){
                type = this.inputType == 'password' ? 'text' : 'password';
            }
            this.inputType = type;
        },
    },
    mounted(){
        if(this.type == "password"){
            this.showSuffix = false;
        }
    },
    watch: {
        value(value){
            this.inputValue = value;
        }
    }
}
</script>